import { defineStore } from 'pinia'
import Axios from 'axios'
import { useProcessoParadigmaStore } from "@/store/processoparadigma-store"
import {useProcessoIncidenteStore} from "@/store/processoincidente-store";

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const TEMA_URL = BASE_URL + "api/demandasrepetitivas/tema"
export const useTemaStore = defineStore('tema', {
  state: () => ({
    temas: {},
    temasCount: 0,
    pages: {},
    tema: {},
    stgTema: {},

    numProcessoPJe: "",
    numeroUnicoTema: "",
    questao: "",
    tese: "",
    situacao: 0,
    numeroProcesso: "",
    page: 1,
  }),
  getters: {
    all: state => state.temas,
  },
  actions: {
    async resetPagination() {
      this.pages = {}
    },
    async clearStg() {
      this.stgTema = {
        numero: "",
        dataSituacao: null,
        dataAdmissao: null,
        dataJulgamento: null,
        dataTransitoJulgado: null,
        dataPublicacao: null,
        dataSuspensao: null,
        dataFimSuspensao: null,
        textoDecisaoAdmissao: null,
        textoEmentaAdmissao: null,
        textoAcordaoAdmissao: null,
        textoEmentaMerito: null,
        textoAcordaoMerito: null,
        textoDecisaoSuspensao: null,
        relator: null,
        numeroTemaSobrestado: null,
        idRamoDireito: null,
        idSituacaoTema: null,
        questao: null,
        parametro: null,
        detalheAbrangenciaEspecifica: null,
        linkDecisao: null,
        referenciaLegislativa: null,
        ementa: null,
        anotacoesNugep: null,
        processosparadigma: [],
        processosincidente: [],
        numeroUnicoTema: "",
        tese: "",
        statusEnvioBnp: false,
        statusEnvioPje: false,
        assuntoTema: [],
      }
    },
    async fetchStg(id) {
      const tema = await this.fetch(id)
      Object.assign(this.stgTema, tema);
      return this.stgTema
    },
    async fetch(id) {
      const { data } = await Axios.get(TEMA_URL + "/" + id)
      const { tema } = data
      this.temas = {
        ...this.temas, ...Object.fromEntries([[tema.id, tema]])
      }
      return tema

    },
    async fetchPage(page, rowsPerPage) {
      this.page = page || this.page || 1;
      this.rowsPerPage = rowsPerPage || this.rowsPerPage || 10;
      const { data } = await Axios.get(TEMA_URL + "?page=" + this.page + "&itensporpagina=" + this.rowsPerPage + "&numProcessoPJe=" + this.numProcessoPJe + "&numeroUnicoTema=" + this.numeroUnicoTema + "&questao=" + this.questao + "&tese=" + this.tese + "&idSituacaoTema=" + this.situacao)
      const { listaDeTemas, meta } = data
      this.temasCount = meta.totalTemas;
      this.pages[`${this.page}`] = listaDeTemas
      return listaDeTemas
    },
    async saveStg() {
      const fields = [
        "numero",
        "dataSituacao",
        "dataAdmissao",
        "dataJulgamento",
        "dataTransitoJulgado",
        "dataPublicacao",
        "dataSuspensao",
        "dataFimSuspensao",
        "textoDecisaoAdmissao",
        "textoEmentaAdmissao",
        "textoAcordaoAdmissao",
        "textoEmentaMerito",
        "textoAcordaoMerito",
        "textoDecisaoSuspensao",
        "relator",
        "numeroTemaSobrestado",
        "idRamoDireito",
        "idSituacaoTema",
        "idTipoTema",
        "parametro",
        "detalheAbrangenciaEspecifica",
        "linkDecisao",
        "questao",
        "ementa",
        "anotacoesNugep",
        "numeroUnicoTema",
        "referenciaLegislativa",
        "tese",
        "assuntoTema",
        "processosParadigma",
        "processosIncidente",
        "statusEnvioBnp",
        "statusEnvioPje"
      ];

      const filterFields = obj =>
        Object.fromEntries(
          Object.entries(obj).filter(e => fields.includes(e[0]))
        );
      const procStore = useProcessoParadigmaStore()
      const incStore = useProcessoIncidenteStore()
      const payload = filterFields({ ...this.stgTema, processosParadigma: procStore.all, processosIncidente: incStore.all  });
      const result = payload.numero ? await Axios.put(TEMA_URL, payload) : await Axios.post(TEMA_URL, payload)
      return result
    }
  },
})
